import React from 'react';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';


class App extends React.Component {
  constructor() {
    super();
    this.state = {
      lost: false,
      allDone: false,
    };
  }

  componentDidMount() {
    this.newGame();
  }

  nextRound = (theGame) => {
    const possibleAnswers = theGame
      .map(row => 
        row.map(cell => {
          return cell.correct ? [] : cell.answer;
        })
          .reduce((arr, v) => (arr.push(...v), arr), []))
      .reduce((arr, v) => (arr.push(...v), arr), []);
    if (possibleAnswers.length === 0) {
      this.setState({
        allDone: true,
      });
    } else {
      this.setState({
        question: possibleAnswers[Math.round(Math.random() * (possibleAnswers.length-1))],
      });
    }
  }
  
  onAnswer = (rowNumber, colNumber) => {
    if (this.state.game[rowNumber][colNumber].correct) {
      // ignore, has already been correct answer
    } else if (this.state.question == this.state.game[rowNumber][colNumber].answer) {
      let newGame = JSON.parse(JSON.stringify(this.state.game));
      newGame[rowNumber][colNumber].correct = true;
      this.setState({
        game: newGame,
      });
      this.nextRound(newGame);
    } else if (this.state.stars > 1) {
      this.setState({
        stars: this.state.stars - 1,
      });
    } else {
      this.setState({
        lost: true,
      });
    }
  }
  
  makeRow = (rowNumber) => {
    return [...Array(3).keys()].map(colNumber => (
      <span 
        className={`bingo-cell ${this.state.game[rowNumber][colNumber].correct ? " correct" : ""}`}
        onClick={() => this.onAnswer(rowNumber, colNumber)}
      >
        {this.state.game[rowNumber][colNumber].answer * this.state.timesTable}
      </span>
    ));
  }

  newGame = () => {
    let game = [];
    let answers = [...Array(13).keys()];
    
    for (let rowNumber = 0; rowNumber < 2; rowNumber++ ) {
      let row = [];
      for (let colNumber = 0; colNumber < 3; colNumber++ ) {
        let index = Math.round(Math.random() * (answers.length-1) );
        let next = answers.splice(index, 1);
        row.push({
          answer: next,
          correct: false,
        });
      }
      game.push(row);
    }
    this.setState({
      game,
      stars: 3,
      allDone: false,
      lost: false,
    });
    this.nextRound(game);
    this.startTime = new Date();
  }

  newTimesTable = () => {
    this.setState({
      timesTable: null,
    });
    this.newGame();
  }

  finished = (message) => {
    return (
      <div className="bingo-game">
        <div className="finished">
          {message}
        </div>
        <div className="play-again">
          <button onClick={() => this.newGame()}>Play Again?</button>
        </div>
        <div className="play-again">
          <button onClick={() => this.newTimesTable()}>New times table?</button>
        </div>
      </div>  
    );
  }

  onSelectTimes = (val) => {
    this.setState({
      timesTable: val,
    });
  }

  welcome = () => {
    var options = [...Array(11).keys()].map(i => (<option>{i+2}</option>));
    return (
      <div className="welcome">
        <div className="title">
          Alex's tt bingo
        </div>
        <div className="choose-tt" onChange={e => this.onSelectTimes(e.target.value)}>
          Which times table?
            <select>
              <option>-- chose --</option>
              {options}
            </select>
        </div>
      </div>
    );
  }

  gameBoard = () => {
    const rows = [...Array(2).keys()].map(i => (
      <div className="bingo-row">
        {this.makeRow(i)}
      </div>
    ));

    return (
      <div className="bingo-game">
        <div className="question">
          <span>What is {this.state.question} x {this.state.timesTable}?</span>
        </div>

        <div className="bingo-rows">
          {rows}
        </div>  

        <div className="stars">
          <span>
            {[...Array(this.state.stars).keys()].map(i => (
              <FontAwesomeIcon
                  icon={faStar}
                  onClick={this.toggleDisplayEditSettings}
                />            
            ))}
          </span>
        </div>
      </div>
    );
  }
  
  render() {
    return (
      <div className="App">
        { this.state.timesTable == null ? this.welcome() : undefined }
        { this.state.lost ? this.finished("Sorry, you got too many wrong") : undefined }
        { this.state.allDone ? this.finished(`You finished in ${Math.round((new Date().getTime() - this.startTime.getTime()) / 100) / 10} seconds`) : undefined }
        { !this.state.lost && !this.state.allDone && this.state.game != null && this.state.timesTable != null ? this.gameBoard() : undefined }
        <div className="footer">
          <span>Copyright &copy; 2020 Alex &amp; his Dad</span>
        </div>
      </div>
    );
  }
}

export default App;
